import React, { useEffect, useRef, useState } from 'react'
import { Baseurl, getBaner, getPromocode, dealProductList, getDeals, createDeal, getCategory, getCountry } from '../../../service/apiService'
import Addmodal from '../../common/Modals/Addmodal'
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Editor } from 'primereact/editor';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon'
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';
import { useSnackbar } from 'notistack';
import Deletemodal from '../../common/Modals/Deletemodal';
import QuillTextDisplay from '../../common/Quiltext/QuillTextDisplay';

const UserHome = () => {
 const [activeTab, setActiveTab] = useState('banner')
 const [banerapidata, setBanerapidata] = useState([])
 const [promocodedata, setPromocodedata] = useState([])
 const [propstring, setPropstring] = useState()
 const [uniqueid, setUniqueid] = useState()
 const [stepper, setStepper] = useState(false)
 const [adddealModal, setAdddealModal] = useState(false)
 const [addpromcode, setAddpromocode] = useState(false)
 const{enqueueSnackbar} = useSnackbar();
 const [dealdata, setDealddata] = useState([])
 const [globalFilterValue, setGlobalFilterValue] = useState('');

 const [description, setDescription] = useState();
 const [name, setName] = useState()
 const [products, setProducts] = useState([])
 
 const [startdate, setStartdate] = useState()
 const [enddate, setEnddate] = useState() 
const [payloadobject,setPayloadobject] = useState([])
const [discountprice, setDiscountprice] = useState([]) 
const [value, setValue] = useState();
const [removemodal, setRemovemodal] = useState(false)
const [country,setCountry] = useState([])


 const stepperRef = useRef(null);


      const onGlobalFilterChange = (e) => {
         const value = e.target.value;
         let _filters = { ...filters };
 
         _filters['global'].value = value;
 
         setFilters(_filters);
         setGlobalFilterValue(value);
     };
 
     const renderHeader = () => {
       return (
           <div className="d-flex justify-content-end">
               <IconField iconPosition="left">
                   <InputIcon className="pi pi-search" />
                   <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
               </IconField>
           </div>
       );
   };
 
   const header = renderHeader();

 const addDeals = async () => {
  await getDeals().then((res) => {
  if(res){
  if(res?.data?.message === 'end'){
  return enqueueSnackbar('Deal Allready Running Try Edit', {variant:'warning'})
  } 
  if(res?.data?.message === 'finish' || res?.data?.message === 'start'){
    setStepper(true)
  }
 }
  }).catch((err) => console.log(err))
  
  //setPropstring('deal')
  //setAdddealModal(true)
 } 
  const editDeals = async () => {
    await getDeals().then((res) => {
      if(res){
      if(res?.data?.message === 'end'){
        enqueueSnackbar('Deal Edit', {variant:'success'})

        const resultObject = res?.data?.dealdata.products.reduce((accumulator, currentObject) => {
  accumulator[currentObject.productId] = currentObject.discount; 
  return accumulator;
}, {});
const discprice = res?.data?.dealdata.products?.map(itm => itm?.productId) 

      setPayloadobject(res?.data?.dealdata.products)  
      setDiscountprice(discprice)
      setDiscountValues(resultObject)
      setName(res?.data?.dealdata?.dealName)
      setDescription(res?.data?.dealdata?.description)
      setEnddate(new Date(res?.data?.dealdata?.endDate))
      setStepper(true)
      } 
      if(res?.data?.message === 'finish' || res?.data?.message === 'start'){
        return enqueueSnackbar('No Active Deals', {variant:'error'})
      }
     }
      }).catch((err) => console.log(err))
 } 

 const deleteDeal = () => {
  setPropstring('deletedeal')
 setRemovemodal(!removemodal)
 }
 const addCode = () => {
  setPropstring('code')
  setAdddealModal(true)
 } 

 const addCountry = () => {
  setPropstring('country')
  setAdddealModal(true)
 } 

 const updateFooter = () => {
  setPropstring('updatefooter')
  setAdddealModal(true)
 }
 const EditCountry = (id) => {
  setPropstring('editcountry')
   setUniqueid(id)
  setAdddealModal(true)
 }

 const closeDealModal = () => {
  setAdddealModal(false)
 } 
 const AddBanerDetails = () => {
  setPropstring('baner')
  setAdddealModal(true)
 } 

const init = async () => {
 let result = await getBaner()
 setBanerapidata(result?.data)
 let promdata = await getPromocode()
 setPromocodedata(promdata?.data)
 let prod = await dealProductList()
 setProducts(prod?.data?.data)
 
//  let deal = await getDeals()
//  setDealddata(deal?.data)
 let country = await getCountry()
 setCountry(country?.data)
} 

const EditBanner = async (id) => {
   await setUniqueid(id)
  setPropstring('editbaner')
  setAdddealModal(true)
 } 
const DeleteBanner = (id) => {
setPropstring('deletebaner')
setUniqueid(id)
setRemovemodal(!removemodal)
}

const deleteCountry = (id) => {
setPropstring('deletecountry')
setUniqueid(id)
setRemovemodal(!removemodal)
}
 const EditCode = async (id) => {
  await setUniqueid(id)
 setPropstring('editcode')
 setAdddealModal(true)
}
const deleteCode = async (id) => {
  await setUniqueid(id)
 setPropstring('deletecode')
 setRemovemodal(!removemodal)
}
const AfterPropOperation = async () => {
 if(propstring === 'editbaner' || propstring === 'baner' || propstring === 'deletebaner'){
  let result = await getBaner()
  setBanerapidata(result?.data)
 }
 if(propstring === 'code' || propstring === 'editcode' || propstring === 'deletecode' ){
  let promdata = await getPromocode()
  setPromocodedata(promdata?.data)
 }
 if(propstring === 'country' || propstring === 'editcountry' || propstring === 'deletecountry' ){
  let country = await getCountry()
 setCountry(country?.data)
 }
 if(propstring === 'updatefooter'  ){
//   let country = await getCountry()
//  setCountry(country?.data)
alert('data updated')
 }
}

const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    'name': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'category.name': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'brand.name': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'ourprice': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    'mrpprice': { value: null, matchMode: FilterMatchMode.STARTS_WITH },

});

  const cliked = async (id, rowdata) => {
  setDiscountprice((prevItems) => [...prevItems, id])
  } 

  const setDiscountProperty = async (id, rowdata) => {
    if(value >= rowdata?.ourprice){
      return enqueueSnackbar('discount price cant be more than or same as product ourprice',{variant: 'error'})
    }
    let  payloadIds = payloadobject.map(itm => itm?.productId)
    if(payloadIds?.includes(id)){
      let payIndex = payloadobject.findIndex(itm => itm?.productId === id)
      console.log(payIndex,'payIndex');
      
      payloadobject[payIndex].discount = discountValues[id]
    //      setProducts((prevItems) => {
    //   return prevItems.map((item) => {
    //     if (item.id === rowdata.id) {
    //        return {
    //       ...item,
    //       productId: id,
    //       discount: value,
    //     };// Merge the new property with the existing item
    //     }
    //     return item; // Keep other items unchanged
    //   });
    // });
      return enqueueSnackbar('Product updated',{variant: 'success'})

    }
  let newProperty = { productId: id, discount: value };
    setPayloadobject((prev) => [...prev, newProperty]);
    setProducts((prevItems) => {
      return prevItems.map((item) => {
        if (item.id === rowdata.id) {
           return {
          ...item,
          productId: id,
          discount: value,
        };// Merge the new property with the existing item
        }
        return item; // Keep other items unchanged
      });
    });
    enqueueSnackbar('Product added to deal',{variant: 'success'})
    console.log(payloadobject, 'payload');
    
} 
 const [discountValues, setDiscountValues] = useState({}); // State object for discount prices

const removeProductFromDeal = (id) => {
  console.log(discountprice,'qwe')
  let ts = discountprice.filter((itm) => itm !== id)
  console.log(discountprice,'qwe',ts)
  setDiscountprice(discountprice.filter((itm) => itm !== id))
  setPayloadobject(payloadobject.filter((itm) => itm?.productId !== id ));
  setDiscountValues((prevDiscountValues) => {
    const newDiscountValues = { ...prevDiscountValues }; // Create a shallow copy
    delete newDiscountValues[id];
    return newDiscountValues;
  });
}
 const SaveDeal = async () => {
const uniqueProducts = [];
const seenProductIds = new Set();

for (const product of payloadobject) {
  if (!seenProductIds.has(product.productId)) {
    uniqueProducts.push(product);
    seenProductIds.add(product.productId);
  }
}
 let params = {
  dealName: name,
  products: uniqueProducts,
  description,
  //startDate: startdate.toISOString(),
  endDate: enddate.toISOString()
 }
 let result = await createDeal(params)
if(result){
  alert('Deal Saved')
}
  setPayloadobject([])  
      setDiscountprice([])
      setDiscountValues([])
      setName('')
      setDescription('')
      setEnddate('')
setStepper(false); 
 }


 const handleValueChange = (rowId, newValue) => {
     setDiscountValues({ ...discountValues, [rowId]: newValue });
     setValue(newValue)
 };

useEffect(() => {
( async () => {
  await init()
})()
},[]) 

 useEffect(() => {
console.log('hai helo');

},[])                         

  return (
    <div>
         <div class="right-content">
                             <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                               <h1>Home</h1> 
                             </div>
                             <div class="container-fluid p-0">
                               <div class="settings-tabs">
                                <div>
                                  <ul class="nav nav-tabs">
                                    <li class="nav-item">
                                      <a className={`nav-link ${activeTab === 'banner' ? 'active' : ''}`} onClick={() => setActiveTab('banner')}>
                                       <img src="/images/myprofile.svg" />  
                                       <div>
                                        <h6>Banner</h6> 
                                       </div>     
                                      </a>
                                    </li>
                                    <li class="nav-item">
                                      <a className={`nav-link ${activeTab === 'footer' ? 'active' : ''}`} onClick={() => setActiveTab('footer')}>
                                       <img src="/images/myprofile.svg" />  
                                       <div>
                                        <h6>Footer</h6> 
                                       </div>     
                                      </a>
                                    </li>
                                    <li class="nav-item">
                                      <a className={`nav-link ${activeTab === 'deal' ? 'active' : ''}`} data-bs-toggle="tab" href="#home" onClick={() => setActiveTab('deal')}>
                                       <img src="/images/myprofile.svg" />  
                                       <div>
                                        <h6>Deals</h6> 
                                       </div>     
                                      </a>
                                    </li>
                                    <li class="nav-item">
                                      <a className={`nav-link ${activeTab === 'code' ? 'active' : ''}`} data-bs-toggle="tab" href="#home" onClick={() => setActiveTab('code')}>
                                       <img src="/images/myprofile.svg" />  
                                       <div>
                                        <h6>Promo Code</h6> 
                                       </div>     
                                      </a>
                                    </li>
                                  </ul> 
                                 </div>
                                  
                                   <div class="full">
                                   {adddealModal ? <Addmodal show={adddealModal} handleClose={closeDealModal} from={propstring} initRefresh={AfterPropOperation} uniqueId={uniqueid} /> : <></>}
                                   {removemodal ? <Deletemodal initRefresh={AfterPropOperation} isModalOpen={removemodal} id={uniqueid} closeModal={() => setRemovemodal(!removemodal)} from={propstring} /> : <></>}
                                  <div class="tab-content h-100">
                                    <div  className={`tab-pane container ${activeTab === 'banner' ? 'active' : 'fade'}`} >
                                    {/* <div className='text-white'>{ blogmodal ? <Deletemodal idtodelete={idtodelete} initRefresh={afterBrandDelete} isModalOpen={brandmodal} closeModal={handleCloseBrand} from={'brand'} /> : <></> }</div>  */}
                                    {/* <div className='text-white'>{ brandaddmodal ? <Addmodal show={brandaddmodal} idtodelete={idtodelete} handleClose={handleCloseBrandAdd} brand={editstring} initRefresh={afterBrandAdd}  /> : <></> } </div>  */}
                                      <div class="card mb-4 bg-curve">
                                        <div class="d-flex justify-content-between card-head align-items-center">
                                          <h2 className="mt-3 text-white">Details of Banner</h2>
                                        <button className="tb-add-btn" onClick={AddBanerDetails}>AddBanerDetails+</button>
                                        </div>
                                        <div class="table-responsive cmn-table dragscroll">
                                      <table class="w-100">
                                       <thead>
                                        <tr className='text-white'>  
                                        <th>Sl No.</th>   
                                        <th>Baner Name</th>
                                        <th>Heading</th>
                                        <th>Button link</th>
                                        <th>Edit</th>  
                                        <th>Delete</th>       
                                       </tr>
                                       </thead>
                                       <tbody className='w-100 text-white'>
                                        {banerapidata.map((item,index) => {
                                          return(
                                            <tr key={index}>
                                            <td>{index+1}</td> 
                                            <td><img src={`${Baseurl}/view/imageupload/${item.img}?t=${new Date().getTime()}`} class="user-img me-2" />{item?.name}</td>
                                          
                                            <td>{item?.heading}</td>
                                            <td>{item?.button}</td>
                                           <td> <button class="act-btns" onClick={() => {EditBanner(item._id)}} ><i class="far fa-redo-alt"></i> Edit</button>  </td> 
                                            <td> <button class="act-btns" onClick={() => {DeleteBanner(item._id)}} ><i class="far fa-redo-alt"></i> Delete</button>  </td> 

                                            <td>
                                            {/* <button class="act-btns" onClick={() => {deleteBrand(item._id)}} data-bs-toggle="modal" data-bs-target="#edit-comm"><i class="far fa-edit"></i> Delete</button> */}
                                            </td>
                                        </tr>)
                                        })}
                                       </tbody>
                                      </table>
                                      </div>
                                      </div> 
                                    </div>

                                    <div  className={`tab-pane container ${activeTab === 'footer' ? 'active' : 'fade'}`} id="footer">
                                    {/* <div className='text-white'>{ blogmodal ? <Deletemodal idtodelete={idtodelete} initRefresh={afterBrandDelete} isModalOpen={brandmodal} closeModal={handleCloseBrand} from={'brand'} /> : <></> }</div>  */}
                                    {/* <div className='text-white'>{ brandaddmodal ? <Addmodal show={brandaddmodal} idtodelete={idtodelete} handleClose={handleCloseBrandAdd} brand={editstring} initRefresh={afterBrandAdd}  /> : <></> } </div>  */}
                                      <div class="card mb-4 bg-curve">
                                        <div class="d-flex justify-content-between card-head align-items-center">
                                          <h2 className="mt-3 text-white">Details of Footer</h2>
                                        <button className="tb-add-btn" onClick={addCountry}>AddCountry+</button>
                                        <button className="tb-add-btn" onClick={updateFooter}>Update Footer+</button>
                                        </div>
                                        <div class="table-responsive cmn-table dragscroll">
                                      <table class="w-100">
                                       <thead>
                                        <tr className='text-white'>  
                                        <th>Sl No.</th>   
                                        <th>Country Name</th>
                                        <th>Edit</th>  
                                        <th>Delete</th>       
                                       </tr>
                                       </thead>
                                       <tbody className='w-100 text-white'>
                                        { country?.map((item,index) => {
                                          return(
                                            <tr key={index}>
                                            <td>{index+1}</td> 
                                            <td><img src={`${Baseurl}/view/imageupload/${item?.img}?t=${new Date().getTime()}`} class="user-img me-2" />{item?.name}</td>
                                            <td>
                                            <button class="act-btns" onClick={() => {EditCountry(item._id)}} ><i class="far fa-redo-alt"></i> Edit</button>  
                                            </td>
                                            <td>
                                            <button class="act-btns" onClick={() => {deleteCountry(item._id)}} ><i class="far fa-edit"></i> Delete</button>
                                            </td>
                                            <td></td>
                                        </tr>)
                                        })} 
                                       </tbody>
                                      </table>
                                      </div>
                                      </div> 
                                    </div>

                                    
                                    <div  className={`tab-pane container ${activeTab === 'deal' ? 'active' : 'fade'}`} id="footer">
                                    {/* <div className='text-white'>{ blogmodal ? <Deletemodal idtodelete={idtodelete} initRefresh={afterBrandDelete} isModalOpen={brandmodal} closeModal={handleCloseBrand} from={'brand'} /> : <></> }</div>  */}
                                    {/* <div className='text-white'>{ brandaddmodal ? <Addmodal show={brandaddmodal} idtodelete={idtodelete} handleClose={handleCloseBrandAdd} brand={editstring} initRefresh={afterBrandAdd}  /> : <></> } </div>  */}
                                    <button className="tb-add-btn" onClick={addDeals}>Add Deals</button>
                                     <button className="tb-add-btn" onClick={editDeals}>Edit Deals</button>
                                     <button className="tb-add-btn" onClick={deleteDeal}>Delete Deal</button>


                                    </div>

            {stepper ?  <div className=" flex justify-content-center w-100">
          <Dialog header="Create Deals" visible={stepper} style={{ width: '90vw' }} onHide={() => {if (!stepper) return; setStepper(false); }}>
            <div className=" flex justify-content-center">
        <Stepper ref={stepperRef} style={{ flexBasis: '50rem' }} >
            <StepperPanel header="Describe Deal">
                <div className="d-flex flex-column h-100">
                    <div style={{height:'400px'}} className="border-2 border-dashed surface-border border-round surface-ground d-flex  justify-content-center align-items-center font-medium">
                      <div className=' w-100 h-100'>
                      <label>Name</label>
                      <input type="text" value={name} className="form-control" placeholder="Deal Name" onChange={(e)=>{setName(e.target.value)}} />
                       <label className='mt-1'>DESCRIPTION</label>
                        <Editor id='editor' className="text-dark" value={description} onTextChange={(e) => setDescription(e.htmlValue)} style={{ height: '220px' }} />
                      </div>
                    </div>
                </div>
                <div className="d-flex  pt-4 justify-content-end ">
                    <Button label="Next" icon="pi pi-arrow-right" disabled={!name || !description} iconPos="right" onClick={() => stepperRef.current.nextCallback()} />
                </div>
            </StepperPanel>
            <StepperPanel header="Select Products">
                <div className="d-flex  flex-column h-12rem">
                    <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                      <div>
                               <DataTable className='z-index-n1' value={products} paginator rows={10} dataKey="_id" filters={filters} filterDisplay="row"
                               globalFilterFields={['name', 'category.name', 'brand.name', 'ourprice', 'mrpprice']} header={header} emptyMessage="No Data found." >
                               
                                <Column field="name" header="Name" filter filterPlaceholder="Search by Name" style={{ minWidth: '12rem' }} />
                                <Column field="category.name" header="Category" filter filterPlaceholder="Search Category" style={{ minWidth: '12rem' }} />
                                <Column field="brand.name" header="Brand" filter filterPlaceholder="Search Brand" style={{ minWidth: '12rem' }} />
                                <Column field="ourprice" header="Our Price" filter filterPlaceholder="Search ourprice" style={{ minWidth: '12rem' }} />
                                <Column field="mrpprice" header="Mrp Price" filter filterPlaceholder="Search Mrp" style={{ minWidth: '12rem' }} />
                                
 
                        
                            <Column field="Actions" header="Actions" body={(rowData) => (
                            <span>
                            {discountprice?.includes(rowData._id) ?
                            <span className='d-flex justify-content-between'>
                            <InputNumber  value={discountValues[rowData._id] || null}  onValueChange={(e) => handleValueChange(rowData._id, e.value)} showButtons buttonLayout="horizontal" />
                            <Button className='ms-2' label='Save Discount'  onClick={() => {setDiscountProperty(rowData._id,rowData)}}/> 
                            <Button className='ms-2 text-center' label='Remove'  onClick={() => {removeProductFromDeal(rowData._id,rowData)}}/> </span>
                              :
                            <Button label='Add to Deals'  onClick={() => {cliked(rowData._id,rowData)}}/>}
                            </span>)} style={{ minWidth: '12rem' }}  />
                               </DataTable>
                      </div>
                    </div>
                </div>
                <div className="d-flex  pt-4 justify-content-between">
                    <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} />
                    <Button label="Next" icon="pi pi-arrow-right" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />
                </div>
            </StepperPanel>
            <StepperPanel header="Save Deal">
                <div className="d-flex  flex-column h-12rem">
                    <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                      <div>
                      {/* <div>
                      <label>Start Date</label>
                          <Calendar id="buttondisplay" className='ms-5'  showTime
                                        showSeconds
                                        dateFormat="yy-mm-dd"
                                        timeFormat="HH:mm:ss" value={startdate} onChange={(e) => setStartdate(e.value)} showIcon />
                      </div> */}
                      <div className='mt-2'>
                      <label>End Date</label>
                        <Calendar id="buttondisplay" className='ms-5'  showTime 
                                      showSeconds
                                      dateFormat="yy-mm-dd"
                                      timeFormat="HH:mm:ss" value={enddate} onChange={(e) => setEnddate(e.value)} showIcon />                  
                      </div>
                      </div>
                    </div>
                </div>
                <div className="d-flex  pt-4 justify-content-between">
                    <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => stepperRef.current.prevCallback()} />
                    <Button label='Submit' onClick={SaveDeal}/>
                </div>
            </StepperPanel>
        </Stepper>
    </div>
            </Dialog> 
        </div> : <></> }

                                    <div  className={`tab-pane container ${activeTab === 'code' ? 'active' : 'fade'}`} id="footer">
                                    {/* <div className='text-white'>{ blogmodal ? <Deletemodal idtodelete={idtodelete} initRefresh={afterBrandDelete} isModalOpen={brandmodal} closeModal={handleCloseBrand} from={'brand'} /> : <></> }</div>  */}
                                    {/* <div className='text-white'>{ brandaddmodal ? <Addmodal show={brandaddmodal} idtodelete={idtodelete} handleClose={handleCloseBrandAdd} brand={editstring} initRefresh={afterBrandAdd}  /> : <></> } </div>  */}
                                    <button className="tb-add-btn mb-2" onClick={addCode}>Add PromoCode</button>
                                    <div class="card mb-4 bg-curve">
                                        <div class="d-flex justify-content-between card-head align-items-center">
                                          <h2 className="mt-3 text-white">Codes</h2>
                                        {/* <button className="tb-add-btn" onClick={handleShowBrandAdd}>  {props.from === 'cms' ? 'AddBlog+' : 'AddBrand+' }</button> */}
                                        </div>
                                        <div class="table-responsive cmn-table dragscroll">
                                      <table class="w-100">
                                       <thead>
                                        <tr className='text-white'>  
                                        <th>Sl No.</th>   
                                        <th>PromoCode Name</th>
                                        <th>discountAmount</th>
                                        <th>discountType</th>
                                         <th>Description</th>
                                        <th>Valid</th>
                                        <th>minimumPurchaseRate</th>
                                        <th>maximumRedemtionLimit</th>
                                        <th>expiryDate</th>
                                        <th>Edit</th>  
                                        <th>Delete</th>       
                                       </tr>
                                       </thead>
                                       <tbody className='w-100 text-white'>
                                        {promocodedata?.map((item,index) => {
                                          return(
                                            <tr key={index}>
                                            <td>{index+1}</td> 
                                            <td>{item?.Name}</td>
                                            <td>{item?.discount} {item?.discountType === 'Percentage' ? '%' : <></>}</td> 
                                            <td>{item?.discountType}</td> 
                                            <td><QuillTextDisplay text = {item?.description} /></td>
                                            <td>{item?.valid ? 'Active' : 'InActive'}</td>
                                            <td>{item?.minimumPurchaseRate}</td>
                                             <td>{item?.maximumRedemtionLimit}</td>
                                            <td>{new Date(item?.expiryDate)?.toLocaleString() }</td>
                                            <td>
                                            <button class="act-btns" onClick={() => {EditCode(item._id)}} ><i class="far fa-redo-alt"></i> Edit</button>  
                                            </td>
                                            <td>
                                            <button class="act-btns" onClick={() => {deleteCode(item._id)}} ><i class="far fa-edit"></i> Delete</button>
                                            </td>
                                        </tr>)
                                        })}
                                       </tbody>
                                      </table>
                                      </div>
                           
                                      </div> 

                                    </div>
                                  </div>
                                   </div>
                               </div>
                             </div>  
                          </div>
    </div>
  )
}

export default UserHome
